/**
 * Created by wajidafaneh on 5/2/17.
 */
window.GPSAPI = new function () {

    var self = this;
    var _protected = BaseAPI.call(self);
    var GPs = {};
    self.getGP = function (gpId) {
        var deferred = $q.defer();

        if (!_.isEmpty(GPs[gpId])) {
            deferred.resolve(GPs[gpId]);
        } else {
            _protected.request("gps/" + gpId, "GET")
                .then(function (res) {
                    if (res.status === 200 && res.data && res.data.data) {
                        GPs[gpId] = res.data.data;
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                })
                .catch(function (err) {
                    deferred.reject(err);
                });
        }

        return deferred.promise;
    };
};
